import { Translate, trans } from '@lingoda/i18n';
import { StepComponent } from './StepComponent';

export const Step3 = () => (
    <StepComponent title={trans('product-tour-step3-title', {}, 'student-common')}>
        <Translate id="product-tour-step3-description" domain="student-common" component="div" />
    </StepComponent>
);
